import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/tmp/seed/source/app/(normal)/clientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/tmp/seed/source/app/(providers)/PostHogProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/app/sign-up/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/tmp/seed/source/lib/theme.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ColorSchemeScript"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/MantineProvider/ColorSchemeScript/ColorSchemeScript.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Notifications"] */ "/tmp/seed/source/node_modules/@mantine/notifications/esm/Notifications.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/seed/source/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/tmp/seed/source/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-mono\"}],\"variableName\":\"fontMono\"}");
